import React from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { Modal, Button } from '@bingads-webui-react/primitive';
import { ReactTemplate } from '@bingads-webui-react/react-template';
import type { InvoiceAblEnforcementDialogProps } from './types';

/* Warning dialog for invoice accounts without ABL
* @property {Object} i18n - i18n object which offers localized string
* @property {bool} isDisplayed - indicate whether to show the warning
* @property {func} onApplyAction - callback to react to apply button
* @property {func} onCancelAction - callback to react to cancel button
*/
export function InvoiceAblEnforcementDialog({
  i18n,
  isDisplayed,
  onApplyAction,
  onCancelAction,
}: InvoiceAblEnforcementDialogProps) {
  return (
    <Modal show={isDisplayed} backdrop="static" className="abl-block-lightbox" onHide={onCancelAction}>
      <Modal.Header closeButton>
        <Modal.Title>{i18n.getString(_TL_('Required updates'))}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>{i18n.getString(_TL_("Before you can continue, we need you to provide important business information that's missing for this account. Every Microsoft Advertising account needs to have:"))}</div>
        <li><b>{i18n.getString(_TL_('A legal business name'))}</b></li>
        <li><b>{i18n.getString(_TL_('A full business address, including country/region'))}</b></li>
        <li><b>{i18n.getString(_TL_('Business tax/VAT registration number (if applicable)'))}</b></li>
        <p>
          <ReactTemplate
            model={{ buttonName: <b>{i18n.getString(_TL_('Update now'))}</b> }}
            template={i18n.getString(_TL_('Click {{buttonName}} to provide this information.'))}
          />
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button className="btn-apply btn-primary" onClick={onApplyAction}>{i18n.getString(_TL_('Update now'))}</Button>
        <Button className="btn-cancel btn-default" onClick={onCancelAction}>{i18n.getString(_TL_('Cancel'))}</Button>
      </Modal.Footer>
    </Modal>
  );
}

InvoiceAblEnforcementDialog.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  isDisplayed: PropTypes.bool,
  onApplyAction: PropTypes.func.isRequired,
  onCancelAction: PropTypes.func,
};

InvoiceAblEnforcementDialog.defaultProps = {
  isDisplayed: false,
  onCancelAction: _.noop,
};
